import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import '../../pages/jobdesccandidatelist/jdcandidatelist.css';

const JdCandidateSearch = ({ setFilterValues, setIsfilterSearch, isVetScreenOpen }) => {
    const [formValues, setFormValues] = useState({
        candidateName: "",
        candidateEmail: "",
    });

    const handleChange = (field, value) => {
        setFormValues(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSearch = () => {
        setFilterValues(formValues);
        setIsfilterSearch(true);
    };

    return (
        <div className='search_main_Container'>
            <div className='search_btn_box'>
                <div className='text_top'>
                    <Typography >Showing Results</Typography>
                    <Typography style={{ color: 'gray', marginTop: "2%" }}>{isVetScreenOpen ? "JD" : "VET"} Candidate List</Typography>
                </div>

                <div className='search_btn_top'>
                    <button className='search_btn' sx={{ cursor: "pointer" }} onClick={handleSearch}>Search</button>
                </div>

                
            </div>
                <div className='search_form_container_job_search'>
                <form>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Candidate Name
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Candidate Name"
                            value={formValues.candidateName}
                            onChange={(e) => handleChange('candidateName', e.target.value)}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Candidate Email
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Candidate Email"
                            value={formValues.candidateEmail}
                            onChange={(e) => handleChange('candidateEmail', e.target.value)}
                        />
                    </div>
                </form>
            </div>  
        </div>
    );
};

export default JdCandidateSearch;
